import { Story } from '../../DocTypes';

export const inlineTextStory: Story = {
  title: 'Inline text',
  description: 'List with items having multiple text items inline',
  coreComponent: {
    html: `<tag-list
    left-icon='Badge'
    left-icon-accent='atoll'
    primary-field='name'
    primary-field-inline
    secondary-field='position'
    secondary-field-inline
    >
  </tag-list>`,
    js: `var tagList = document.querySelector('tag-list');
  tagList.componentOnReady().then(function() {
    tagList.setData([
      { name: 'Jordan Pickford', position: 'Goalkeeper' },
      { name: 'Kyle Walker', position: 'Right back' },
      { name: 'John Stones', position: 'Centre Back' },
      { name: 'Harry Maguire', position: 'Centre Back' },
      { name: 'Luke Shaw', position: 'Attacking Midfield' }
    ]);
  });
    `,
  },
  // coreComponent_v3: {
  //   html: `<tag3-list
  //   left-icon='Badge'
  //   left-icon-accent='atoll'
  //   primary-field='name'
  //   primary-field-inline
  //   secondary-field='position'
  //   secondary-field-inline
  //   >
  // </tag3-list>`,
  //   js: `var tagList = document.querySelector('tag3-list');
  //   tagList.setData([
  //     { name: 'Jordan Pickford', position: 'Goalkeeper' },
  //     { name: 'Kyle Walker', position: 'Right back' },
  //     { name: 'John Stones', position: 'Centre Back' },
  //     { name: 'Harry Maguire', position: 'Centre Back' },
  //     { name: 'Luke Shaw', position: 'Attacking Midfield' }
  //   ]);
  //   `,
  // },
  reactWrapper: {
    jsx: `<TagList
    leftIcon='Badge'
    leftIconAccent='atoll'
    primaryField='name'
    primaryField-inline
    secondaryField='position'
    secondaryFieldInline
    data={[
      { name: 'Jordan Pickford', position: 'Goalkeeper' },
      { name: 'Kyle Walker', position: 'Right back' },
      { name: 'John Stones', position: 'Centre Back' },
      { name: 'Harry Maguire', position: 'Centre Back' },
      { name: 'Luke Shaw', position: 'Attacking Midfield' }
    ]}
  />`,
  },
};
